class Ecommerce {
  quickSearchAjax = null;
  filterAjax = null;
  lastFilterFormData = null;
  lastFilterFormAction = null;
  filterTimeout = null;
  productGalleryInstance = null;
  productGalleryThumbnailsInstance = null;

  showError(message) {
    if (typeof Theme !== "undefined") {
      Theme.showError(message);
    } else {
      console.error("[Ecommerce]", message);
    }
  }

  showSuccess(message) {
    if (typeof Theme !== "undefined") {
      Theme.showSuccess(message);
    } else {
      console.log("[Ecommerce]", message);
    }
  }

  handleError(error, $form = null) {
    if (typeof Theme !== "undefined") {
      Theme.handleError(error, $form);
    } else {
      console.error("[Ecommerce]", error.responseJSON?.message || error.statusText || error);
    }
  }

  updateLazyLoad() {
    if (typeof Theme !== "undefined" && Theme.lazyLoadInstance) {
      Theme.lazyLoadInstance.update();
    }
  }

  getCsrfToken($form = null) {
    if ($form && $form.length) {
      const formToken = $form.find('input[name="_token"]').val();
      if (formToken) {
        return formToken;
      }
    }
    return $('meta[name="csrf-token"]').attr("content") || "";
  }

  getAjaxData(data = {}, $form = null) {
    const token = this.getCsrfToken($form);
    if (token) {
      data._token = token;
    }
    return data;
  }

  updateWishlistButtons(url, added) {
    $('[data-bb-toggle="add-to-wishlist"], [data-bb-toggle="remove-from-wishlist"]')
      .filter(function () {
        return $(this).data("url") === url;
      })
      .each(function () {
        $(this)
          .toggleClass("is-active", added)
          .toggleClass("js-add-to-wishlist-button", !added)
          .toggleClass("js-remove-from-wishlist-button", added)
          .attr("data-bb-toggle", added ? "remove-from-wishlist" : "add-to-wishlist");
      });
  }

  constructor() {
    this.initClipboard();
    this.initFileUpload();

    $(document)
      .on("click", '[data-bb-toggle="quick-shop"]', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const currentTarget = $(e.currentTarget);
        const modal = $("#quick-shop-modal");

        $.ajax({
          url: currentTarget.data("url"),
          type: "GET",
          beforeSend: () => {
            if (modal.find(".quick-shop-content").length) {
              modal.find(".quick-shop-content").html("");
              modal.find(".modal-body").addClass("modal-empty");
              modal.find(".loading-spinner").removeClass("d-none").show();
              modal.find(".quick-shop-content").hide();
            } else {
              modal.find(".modal-body").html("");
            }

            modal.modal("show");

            document.dispatchEvent(
              new CustomEvent("ecommerce.quick-shop.before-send", {
                detail: {
                  element: currentTarget,
                  modal,
                },
              }),
            );
          },
          success: ({ data }) => {
            if (modal.find(".quick-shop-content").length) {
              modal.find(".quick-shop-content").html(data);
              modal.find(".loading-spinner").addClass("d-none").hide();
              modal.find(".modal-body").removeClass("modal-empty");
              modal.find(".quick-shop-content").show();
            } else {
              modal.find(".modal-body").html(data);
            }
          },
          error: (error) => EcommerceApp.handleError(error),
          complete: () => {
            document.dispatchEvent(
              new CustomEvent("ecommerce.quick-shop.completed", {
                detail: {
                  element: currentTarget,
                  modal,
                },
              }),
            );
          },
        });
      })
      .on("click", '[data-bb-toggle="add-to-compare"]', function (e) {
        e.preventDefault();

        const currentTarget = $(e.currentTarget);

        const url = currentTarget.hasClass("active") ? currentTarget.data("remove-url") : currentTarget.data("url");
        let data = currentTarget.hasClass("active") ? { _method: "DELETE" } : {};
        const $form = currentTarget.closest("form");

        $.ajax({
          url,
          method: "POST",
          data: EcommerceApp.getAjaxData(data, $form),
          beforeSend: () => currentTarget.addClass("btn-loading"),
          success: ({ error, message, data }) => {
            if (error) {
              EcommerceApp.showError(message);
            } else {
              EcommerceApp.showSuccess(message);
              currentTarget.toggleClass("active");

              if (data.count !== undefined) {
                $('[data-bb-value="compare-count"]').text(data.count);
              }

              if (currentTarget.hasClass("active")) {
                document.dispatchEvent(
                  new CustomEvent("ecommerce.compare.added", {
                    detail: {
                      data,
                      element: currentTarget,
                      extraData: data.extra_data,
                    },
                  }),
                );
                currentTarget.attr("data-bb-toggle", "remove-from-compare");
              } else {
                document.dispatchEvent(
                  new CustomEvent("ecommerce.compare.removed", {
                    detail: {
                      data,
                      element: currentTarget,
                      extraData: data.extra_data,
                    },
                  }),
                );
                currentTarget.attr("data-bb-toggle", "add-to-compare");
              }
            }
          },
          error: (error) => EcommerceApp.handleError(error),
          complete: () => currentTarget.removeClass("btn-loading"),
        });
      })
      .on("click", '[data-bb-toggle="remove-from-compare"]', (e) => {
        e.preventDefault();

        const currentTarget = $(e.currentTarget);
        const table = currentTarget.closest("table");
        const $form = currentTarget.closest("form");

        $.ajax({
          url: currentTarget.data("url"),
          method: "POST",
          data: EcommerceApp.getAjaxData({ _method: "DELETE" }, $form),
          beforeSend: () => currentTarget.addClass("btn-loading"),
          success: ({ error, message, data }) => {
            if (error) {
              EcommerceApp.showError(message);
            } else {
              EcommerceApp.showSuccess(message);

              document.dispatchEvent(
                new CustomEvent("ecommerce.compare.removed", {
                  detail: {
                    data,
                    element: currentTarget,
                    extraData: data.extra_data,
                  },
                }),
              );

              currentTarget.attr("data-bb-toggle", "add-to-compare");

              if (data.count !== undefined) {
                $('[data-bb-value="compare-count"]').text(data.count);

                if (data.count > 0) {
                  table.find(`td:nth-child(${currentTarget.closest("td").index() + 1})`).remove();
                }
              } else {
                window.location.reload();
              }
            }
          },
          error: (error) => EcommerceApp.handleError(error),
          complete: () => currentTarget.removeClass("btn-loading"),
        });
      })
      .on("click", '[data-bb-toggle="add-to-wishlist"]', function (e) {
        e.preventDefault();

        const currentTarget = $(e.currentTarget);
        const url = currentTarget.data("url");
        const $form = currentTarget.closest("form");

        $.ajax({
          url,
          method: "POST",
          data: EcommerceApp.getAjaxData({}, $form),
          beforeSend: () => currentTarget.addClass("btn-loading"),
          success: ({ error, message, data }) => {
            if (error) {
              EcommerceApp.showError(message);
            } else {
              if (data.count !== undefined) {
                $('[data-bb-value="wishlist-count"]').text(data.count);
              }

              if (data.added) {
                currentTarget.addClass("is-active");
              } else {
                currentTarget.removeClass("is-active");
              }

              EcommerceApp.updateWishlistButtons(url, data.added);

              EcommerceApp.showSuccess(message);

              document.dispatchEvent(
                new CustomEvent("ecommerce.wishlist.added", {
                  detail: {
                    data,
                    element: currentTarget,
                    extraData: data.extra_data,
                    added: data.added,
                  },
                }),
              );
            }
          },
          error: (error) => EcommerceApp.handleError(error),
          complete: () => {
            currentTarget.removeClass("btn-loading");
          },
        });
      })
      .on("click", '[data-bb-toggle="remove-from-wishlist"]', (e) => {
        e.preventDefault();

        const currentTarget = $(e.currentTarget);
        const url = currentTarget.data("url");
        const $form = currentTarget.closest("form");

        $.ajax({
          url,
          method: "POST",
          data: EcommerceApp.getAjaxData({ _method: "DELETE" }, $form),
          beforeSend: () => currentTarget.addClass("btn-loading"),
          success: ({ error, message, data }) => {
            if (error) {
              EcommerceApp.showError(message);
            } else {
              EcommerceApp.showSuccess(message);

              currentTarget.closest("tr").remove();
              EcommerceApp.updateWishlistButtons(url, false);

              if (data.count !== undefined) {
                $('[data-bb-value="wishlist-count"]').text(data.count);

                if (data.count === 0) {
                  window.location.reload();
                }
              }

              document.dispatchEvent(
                new CustomEvent("ecommerce.wishlist.removed", {
                  detail: {
                    data,
                    element: currentTarget,
                    extraData: data.extra_data,
                  },
                }),
              );
            }
          },
          error: (error) => EcommerceApp.handleError(error),
          complete: () => {
            currentTarget.removeClass("btn-loading");
          },
        });
      })
      .on("click", '[data-bb-toggle="add-to-cart"]', (e) => {
        e.preventDefault();

        const currentTarget = $(e.currentTarget);
        const $form = currentTarget.closest("form");
        const quantity = currentTarget.closest("tr").find('input[name="qty"]');
        const data = {
          id: currentTarget.data("id"),
        };

        if (quantity) {
          data.qty = quantity.val();
        }

        $.ajax({
          url: currentTarget.data("url"),
          method: "POST",
          data: EcommerceApp.getAjaxData(data, $form),
          dataType: "json",
          beforeSend: () => currentTarget.addClass("btn-loading"),
          success: ({ error, message, data }) => {
            if (error) {
              EcommerceApp.showError(message);

              if (data && data.next_url !== undefined) {
                setTimeout(() => {
                  window.location.href = data.next_url;
                }, 500);
              }

              return false;
            }

            let showSuccess = true;

            if (currentTarget.data("show-toast-on-success") !== undefined) {
              showSuccess = currentTarget.data("show-toast-on-success");
            }

            if (showSuccess) {
              EcommerceApp.showSuccess(message);
            }

            if (data.count !== undefined) {
              $('[data-bb-value="cart-count"]').text(data.count);
            }

            document.dispatchEvent(
              new CustomEvent("ecommerce.cart.added", {
                detail: {
                  data,
                  element: currentTarget,
                  message,
                  extraData: data.extra_data,
                },
              }),
            );

            if (data && data.next_url !== undefined) {
              window.location.href = data.next_url;
            }
          },
          error: (error) => EcommerceApp.handleError(error),
          complete: () => currentTarget.removeClass("btn-loading"),
        });
      })
      .on("click", '[data-bb-toggle="product-form"] button[type="submit"]', (e) => {
        e.preventDefault();
        const currentTarget = $(e.currentTarget);
        const form = currentTarget.closest("form");
        const data = form.serializeArray();

        if (form.find('input[name="id"]').val() === "") {
          return;
        }

        data.push({ name: "checkout", value: currentTarget.prop("name") === "checkout" ? 1 : 0 });

        $.ajax({
          type: "POST",
          url: form.prop("action"),
          data: data,
          beforeSend: () => {
            currentTarget.prop("disabled", true).addClass("btn-loading");
          },
          success: ({ error, message, data }) => {
            if (error) {
              EcommerceApp.showError(message);

              return;
            }
            EcommerceApp.showSuccess(message);

            form.find('input[name="qty"]').val(1);

            if (data.count !== undefined) {
              $('[data-bb-value="cart-count"]').text(data.count);
            }

            document.dispatchEvent(
              new CustomEvent("ecommerce.cart.added", {
                detail: {
                  data,
                  element: currentTarget,
                  extraData: data.extra_data,
                },
              }),
            );

            Cart.handleUpdateCartContent();

            if (data && data.next_url !== undefined) {
              window.location.href = data.next_url;
            } else {
              $.ajax({
                url: window.siteUrl + "/ajax/cart",
                method: "GET",
                success: function (response) {
                  if (!response.error) {
                    $(".ps-cart--mobile").html(response.data.html);
                    $(".cart-item-count").text(response.data.count);

                    if (typeof Theme.lazyLoadInstance !== "undefined") {
                      Theme.lazyLoadInstance.update();
                    }
                  }
                },
              });
            }
          },
          error: (error) => EcommerceApp.handleError(error),
          complete: () => currentTarget.prop("disabled", false).removeClass("btn-loading"),
        });
      })
      .on("click", ".js-quick-view-button", (event) => {
        event.preventDefault();
        let _self = $(event.currentTarget);
        _self.addClass("button-loading");

        $.ajax({
          url: _self.data("url"),
          type: "GET",
          success: (res) => {
            if (!res.error) {
              $("#product-quickview .ps-product--quickview").html(res.data);

              setTimeout(function () {
                if (typeof EcommerceApp !== "undefined") {
                  EcommerceApp.initProductGallery(true);
                  // EcommerceApp.initQuickViewScrollbars();
                  // EcommerceApp.initQuickViewQuantity();
                }
              }, 200);

              $("#product-quickview").modal("show");

              if (typeof Theme.lazyLoadInstance !== "undefined") {
                Theme.lazyLoadInstance.update();
              }

              document.dispatchEvent(new CustomEvent("ecommerce.quick-view.initialized"));
            }
            _self.removeClass("button-loading");
          },
          error: () => {
            _self.removeClass("button-loading");
          },
        });
      });
  }

  /**
   * @returns {boolean}
   */
  isRtl() {
    return document.body.getAttribute("dir") === "rtl";
  }

  /**
   * @param {JQuery} element
   */
  initLightGallery(element) {
    if (!element.length) {
      return;
    }

    if (element.data("lightGallery")) {
      element.data("lightGallery").destroy(true);
    }

    element.lightGallery({
      selector: ".productDetail__mainImageImg",
      thumbnail: true,
      share: false,
      fullScreen: false,
      autoplay: false,
      autoplayControls: false,
      actualSize: false,
    });
  }

  initProductGallery(onlyQuickView = false) {
    if (!onlyQuickView) {
      const $gallery = $(document).find(".productDetail__mainSwiper");
      const thumbnailsEl = document.querySelector(".productDetail__thumbnailsSwiper");
      const mainEl = document.querySelector(".productDetail__mainSwiper");

      if (!thumbnailsEl || !mainEl) {
        return;
      }

      document.querySelectorAll(".productDetail__thumbnailsSwiper").forEach((thumbnailElement) => {
        if (thumbnailElement.swiper) {
          thumbnailElement.swiper.destroy(true, true);
        }

        const thumbnailsInstance = new Swiper(thumbnailElement, {
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
          direction: window.innerWidth <= 1024 ? "horizontal" : "vertical",
          breakpoints: {
            0: {
              direction: "horizontal",
              slidesPerView: 3,
              spaceBetween: 5,
            },
            350: {
              direction: "horizontal",
              slidesPerView: 4,
              spaceBetween: 5,
            },
            414: {
              direction: "horizontal",
              slidesPerView: 5,
              spaceBetween: 8,
            },
            640: {
              direction: "horizontal",
              slidesPerView: 6,
              spaceBetween: 10,
            },
            1025: {
              direction: "vertical",
              slidesPerView: 6,
              spaceBetween: 10,
            },
          },
        });

        const mainSwiperElement = thumbnailElement.closest(".productDetail__gallery")?.querySelector(".productDetail__mainSwiper");

        if (mainSwiperElement) {
          if (mainSwiperElement.swiper) {
            mainSwiperElement.swiper.destroy(true, true);
          }

          new Swiper(mainSwiperElement, {
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            spaceBetween: 0,
            slidesPerView: 1,
            speed: 500,
            effect: "fade",
            fadeEffect: {
              crossFade: true,
            },
            loop: false,
            thumbs: {
              swiper: thumbnailsInstance,
            },
            navigation: {
              nextEl: ".productDetail__navBtn--next",
              prevEl: ".productDetail__navBtn--prev",
            },
          });
        }
      });
      this.initLightGallery($gallery);
      EcommerceApp.updateLazyLoad();
    }

    // const $quickViewGallery = $(document).find(".bb-quick-view-gallery-images");

    // if ($quickViewGallery.length) {
    //   if ($quickViewGallery.hasClass("slick-initialized")) {
    //     $quickViewGallery.slick("unslick");
    //   }

    //   $quickViewGallery.slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     dots: false,
    //     arrows: true,
    //     adaptiveHeight: false,
    //     rtl: this.isRtl(),
    //   });
    // }
  }

  formatPrice(price, numberAfterDot, x) {
    const currencies = window.currencies || {};

    if (!numberAfterDot) {
      numberAfterDot = currencies.number_after_dot !== undefined ? currencies.number_after_dot : 2;
    }

    const regex = "\\d(?=(\\d{" + (x || 3) + "})+$)";
    let priceUnit = "";

    if (currencies.show_symbol_or_title) {
      priceUnit = currencies.symbol || currencies.title || "";
    }

    if (currencies.display_big_money) {
      let label = "";

      if (price >= 1000000 && price < 1000000000) {
        price = price / 1000000;
        label = currencies.million;
      } else if (price >= 1000000000) {
        price = price / 1000000000;
        label = currencies.billion;
      }

      priceUnit = label + (priceUnit ? ` ${priceUnit}` : "");
    }

    price = price.toFixed(Math.max(0, ~~numberAfterDot)).toString().split(".");

    price = price[0].toString().replace(new RegExp(regex, "g"), `$&${currencies.thousands_separator}`) + (price[1] ? currencies.decimal_separator + price[1] : "");

    if (currencies.show_symbol_or_title) {
      price = currencies.is_prefix_symbol ? priceUnit + price : price + priceUnit;
    }

    return price;
  }

  productQuantityToggle = () => {
    const $container = $('[data-bb-toggle="product-quantity"]');

    $container.on("click", '[data-bb-toggle="product-quantity-toggle"]', function (e) {
      const $currentTarget = $(e.currentTarget);

      let $calculation = $currentTarget.data("value");

      if (!$calculation) {
        return;
      }

      let $input = null;

      if ($calculation === "plus") {
        $input = $currentTarget.prev();
      } else if ($calculation === "minus") {
        $input = $currentTarget.next();
      }

      if (!$input) {
        return;
      }

      let $quantity = parseInt($input.val()) || 1;

      $input.val($calculation === "plus" ? $quantity + 1 : $quantity === 1 ? 1 : $quantity - 1);

      document.dispatchEvent(
        new CustomEvent("ecommerce.cart.quantity.change", {
          detail: {
            element: $currentTarget,
            action: $calculation === "+" ? "increase" : "decrease",
          },
        }),
      );
    });
  };

  onChangeProductAttribute = () => {
    if (!window.onBeforeChangeSwatches || typeof window.onBeforeChangeSwatches !== "function") {
      /**
       * @param {Array<Number>} data
       * @param {jQuery} element
       */
      window.onBeforeChangeSwatches = (data, element) => {
        const form = element.closest("form");
        const $product = $(".productDetail");
        const $form = $product.find(".add-to-cart-form");
        const $quantity = $form.find('input[name="qty"]');

        $product.find(".error-message").hide();
        $product.find(".success-message").hide();
        $quantity.prop("disabled", true);

        if (data) {
          form.find('button[type="submit"]').prop("disabled", true);
          form.find('button[data-bb-toggle="add-to-cart"]').prop("disabled", true);
        }

        if (data && data.attributes) {
          $form.find("button[type=submit]").prop("disabled", true).addClass("btn-disabled");
          $form.find("button[type='button']").prop("disabled", true).addClass("btn-disabled");
        }
      };
    }

    if (!window.onChangeSwatchesSuccess || typeof window.onChangeSwatchesSuccess !== "function") {
      /**
       * @param {{data: Object, error: Boolean, message: String}} response
       * @param {jQuery} element
       */
      window.onChangeSwatchesSuccess = (response, element) => {
        if (!response) {
          return;
        }

        const $product = $(".productDetail");
        const $form = element.closest("form");
        const $button = $form.find('button[type="submit"]');
        const $quantity = $form.find('input[name="qty"]');
        const $quantityButtons = $form.find('button[type="button"]');
        const $available = $product.find(".number-items-available");
        const $sku = $product.find('[data-bb-value="product-sku"]');

        const { error, data } = response;

        if (error) {
          $button.prop("disabled", true);
          $quantity.prop("disabled", true);
          $form.find('input[name="id"]').val("");

          return;
        }

        $button.prop("disabled", false);
        $quantity.prop("disabled", false);
        $quantity.val(1);
        $quantityButtons.prop("disabled", false);
        $form.find('input[name="id"]').val(data.id);

        $product.find('[data-bb-value="product-price"]').text(data.display_sale_price);

        if (data.sale_price !== data.price) {
          $product.find('[data-bb-value="product-original-price"]').text(data.display_price).show();
        } else {
          $product.find('[data-bb-value="product-original-price"]').hide();
        }

        if (data.sku) {
          $sku.text(data.sku);
          $sku.closest("div").show();
        } else {
          $sku.closest("div").hide();
        }

        if (data.error_message) {
          $button.prop("disabled", true);
          $quantity.prop("disabled", true);
          $quantityButtons.prop("disabled", true);

          $available.html(`<span class='text-danger'>${data.error_message}</span>`).show();
        } else if (data.warning_message) {
          $available.html(`<span class='text-warning fw-medium fs-6'>${data.warning_message}</span>`).show();
        } else if (data.success_message) {
          $available.html(`<span class='text-success'>${data.success_message}</span>`).show();
        } else {
          $available.html("").hide();
        }

        $product.find(".bb-product-attribute-swatch-item").removeClass("disabled");
        $product.find(".bb-product-attribute-swatch-list select option").prop("disabled", false);

        const unavailableAttributeIds = data.unavailable_attribute_ids || [];

        if (unavailableAttributeIds.length) {
          unavailableAttributeIds.map((id) => {
            let $swatchItem = $product.find(`.bb-product-attribute-swatch-item[data-id="${id}"]`);

            if ($swatchItem.length) {
              $swatchItem.addClass("disabled");
              $swatchItem.find("input").prop("checked", false);
            } else {
              $swatchItem = $product.find(`.bb-product-attribute-swatch-list select option[data-id="${id}"]`);

              if ($swatchItem.length) {
                $swatchItem.prop("disabled", true);
              }
            }
          });
        }

        $product.find('.productDetail__section[data-type="dropdown"]').each(function () {
          const $select = $(this).find("select");
          const $selected = $select.find("option:selected");

          if (!$selected.prop("disabled")) {
            return;
          }

          const $firstAvailableOption = $select.find("option[value!='']:not(:disabled)").first();

          if ($firstAvailableOption.length && $firstAvailableOption.val() !== $select.val()) {
            $select.val($firstAvailableOption.val()).trigger("change");
          }
        });

        let imageHtml = "";
        let thumbHtml = "";
        let quickViewImageHtml = "";

        const thumbnailsEl = $product.find(".productDetail__thumbnailsSwiper");
        const mainEl = $product.find(".productDetail__mainSwiper");

        const imagePlaceholder = window.siteConfig?.img_placeholder || `${window.siteUrl || ""}/vendor/core/core/base/images/placeholder.png`;
        const imageWithSizes = data.image_with_sizes || {};
        const originImages = Array.isArray(imageWithSizes.origin) ? imageWithSizes.origin : [];
        const thumbImages = Array.isArray(imageWithSizes.thumb) ? imageWithSizes.thumb : [];

        (originImages.length ? originImages : [imagePlaceholder]).forEach(function (item) {
          imageHtml += `<div class="swiper-slide productDetail__mainImageImg" data-src="${item}"><img src='${item}' alt='${data.name}'/></div>`;
          quickViewImageHtml += `<div class="gallery-item"><img class="img-fluid w-100" src='${item}' alt='${data.name}' /></div>`;
        });

        (thumbImages.length ? thumbImages : [imagePlaceholder]).forEach(function (item) {
          thumbHtml += `
                      <div class='swiper-slide productDetail__thumbnail'>
                          <img src='${item}' alt='${data.name}'>
                      </div>
                  `;
        });

        const $galleryImages = $product.find(".productDetail__mainImage");
        const $existingGalleryImages = $galleryImages.find(".swiper-wrapper");
        const $existingThumbnails = $product.find(".productDetail__thumbnailsSwiper").find(".swiper-wrapper");
        const existingVideoElements = $existingGalleryImages.find(".bb-product-video").clone();
        const existingVideoThumbnails = $existingThumbnails.find(".video-thumbnail").clone();

        let finalImageHtml = imageHtml;
        let finalThumbHtml = thumbHtml;
        let finalQuickViewImageHtml = quickViewImageHtml;

        if (existingVideoElements.length > 0) {
          existingVideoElements.each(function () {
            finalImageHtml += $(this)[0].outerHTML;
          });
        }

        if (existingVideoThumbnails.length > 0) {
          existingVideoThumbnails.each(function () {
            finalThumbHtml += `<div>${$(this)[0].outerHTML}</div>`;
          });
        }

        if (finalImageHtml && mainEl) {
          mainEl.find(".swiper-wrapper").html(finalImageHtml);
        }

        if (finalThumbHtml && thumbnailsEl) {
          thumbnailsEl.find(".swiper-wrapper").html(finalThumbHtml);
        }

        const $quickViewGalleryImages = $(document).find(".quick-view-gallery");

        if ($quickViewGalleryImages.length) {
          $quickViewGalleryImages.find(".gallery-main").html(finalQuickViewImageHtml);
        }

        this.initProductGallery();
      };
    }
  };

  initFileUpload() {
    $(document).on("change", ".bb-file-input", (e) => {
      const input = e.target;
      const label = $(input).siblings(".bb-file-label");
      const fileName = label.find(".bb-file-name");
      const placeholder = label.find(".bb-file-placeholder");

      if (input.files && input.files.length > 0) {
        const file = input.files[0];
        fileName.text(file.name);
        label.addClass("has-file");
      } else {
        fileName.text("");
        label.removeClass("has-file");
      }
    });
  }

  initClipboard() {
    $(document).on("click", "[data-ecommerce-clipboard]", async (e) => {
      e.preventDefault();

      const target = $(e.currentTarget);
      const copiedMessage = target.data("clipboard-message");
      const text = target.data("clipboard-text");

      if (!text) {
        return;
      }

      let copied = false;

      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(text);
          copied = true;
        } catch (err) {
          console.warn("Clipboard API failed, falling back to legacy method:", err);
        }
      }

      if (!copied) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          document.execCommand("copy");
          copied = true;
        } catch (err) {
          console.error("Failed to copy text: ", err);
        }

        document.body.removeChild(textArea);
      }

      if (copied) {
        if (copiedMessage) {
          EcommerceApp.showSuccess(copiedMessage);
        }

        const originalHtml = target.html();
        target.html('<i class="ti ti-check"></i> ' + (copiedMessage || "Copied!"));

        setTimeout(() => {
          target.html(originalHtml);
        }, 2000);
      } else {
        EcommerceApp.showError("Failed to copy to clipboard");
      }
    });
  }

  initPriceFilter() {
    if (typeof $.fn.slider === "undefined") {
      throw new Error("jQuery UI slider is required for price filter");
    }

    const $priceFilter = $(document).find(".bb-product-price-filter");
    const $sliderRange = $priceFilter.find(".price-slider");
    const $rangeLabel = $priceFilter.find(".input-range-label");

    if ($priceFilter) {
      const $minPrice = $priceFilter.find('input[name="min_price"]');
      const $maxPrice = $priceFilter.find('input[name="max_price"]');

      const currentMinPrice = parseInt($minPrice.val()) || $sliderRange.data("min");
      const currentMaxPrice = parseInt($maxPrice.val()) || $sliderRange.data("max");
      const isRtl = this.isRtl();

      const sliderMin = isRtl ? -$sliderRange.data("max") : $sliderRange.data("min");
      const sliderMax = isRtl ? -$sliderRange.data("min") : $sliderRange.data("max");
      const sliderValues = isRtl ? [-currentMaxPrice, -currentMinPrice] : [currentMinPrice, currentMaxPrice];

      $sliderRange.slider({
        range: true,
        min: sliderMin,
        max: sliderMax,
        values: sliderValues,
        slide: function (_, ui) {
          const realMin = isRtl ? -ui.values[1] : ui.values[0];
          const realMax = isRtl ? -ui.values[0] : ui.values[1];

          $rangeLabel.find(".from").text(this.formatPrice(realMin));
          $rangeLabel.find(".to").text(this.formatPrice(realMax));
        }.bind(this),
        change: function (_, ui) {
          const realMin = isRtl ? -ui.values[1] : ui.values[0];
          const realMax = isRtl ? -ui.values[0] : ui.values[1];

          if (parseInt(currentMinPrice) !== realMin) {
            $minPrice.val(realMin).trigger("change");
          }

          if (parseInt(currentMaxPrice) !== realMax) {
            $maxPrice.val(realMax).trigger("change");
          }
        }.bind(this),
      });

      const currentValues = $sliderRange.slider("values");
      const displayMin = isRtl ? -currentValues[1] : currentValues[0];
      const displayMax = isRtl ? -currentValues[0] : currentValues[1];

      $rangeLabel.find(".from").text(this.formatPrice(displayMin));
      $rangeLabel.find(".to").text(this.formatPrice(displayMax));
    }
  }

  formatPrice(price, numberAfterDot, x) {
    const currencies = window.currencies || {};

    if (!numberAfterDot) {
      numberAfterDot = currencies.number_after_dot !== undefined ? currencies.number_after_dot : 2;
    }

    const regex = "\\d(?=(\\d{" + (x || 3) + "})+$)";
    let priceUnit = "";

    if (currencies.show_symbol_or_title) {
      priceUnit = currencies.symbol || currencies.title || "";
    }

    if (currencies.display_big_money) {
      let label = "";

      if (price >= 1000000 && price < 1000000000) {
        price = price / 1000000;
        label = currencies.million;
      } else if (price >= 1000000000) {
        price = price / 1000000000;
        label = currencies.billion;
      }

      priceUnit = label + (priceUnit ? ` ${priceUnit}` : "");
    }

    price = price.toFixed(Math.max(0, ~~numberAfterDot)).toString().split(".");

    price = price[0].toString().replace(new RegExp(regex, "g"), `$&${currencies.thousands_separator}`) + (price[1] ? currencies.decimal_separator + price[1] : "");

    if (currencies.show_symbol_or_title) {
      price = currencies.is_prefix_symbol ? priceUnit + " " + price : price + " " + priceUnit;
    }

    return price;
  }
}

$(() => {
  window.EcommerceApp = new Ecommerce();

  EcommerceApp.productQuantityToggle();
  EcommerceApp.initProductGallery();
  EcommerceApp.onChangeProductAttribute();
  // EcommerceApp.initQuickViewScrollbars();

  if ($(".bb-product-price-filter").length) {
    EcommerceApp.initPriceFilter();
  }

  document.addEventListener("ecommerce.quick-shop.completed", () => {
    EcommerceApp.productQuantityToggle();
  });

  // Quick Shop event handlers
  document.addEventListener("ecommerce.quick-shop.before-send", function (e) {
    const { element, modal } = e.detail;
    element.addClass("loading");
    modal.find(".modal-body").html('<div class="ps-loading"><div class="ps-loading__spinner"></div></div>');

    // Mark modal to prevent URL updates
    modal.addClass("quick-shop-no-url-update");
  });

  document.addEventListener("ecommerce.quick-shop.completed", function (e) {
    const { element, modal } = e.detail;
    element.removeClass("loading");

    // Initialize quantity buttons - using the same logic as product detail page
    $(modal)
      .find(".product__qty .up")
      .on("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        let currentVal = parseInt($(this).closest(".product__qty").find(".qty-input").val(), 10) || 0;
        $(this)
          .closest(".product__qty")
          .find(".qty-input")
          .val(currentVal + 1)
          .prop("placeholder", currentVal + 1)
          .trigger("change");
      });

    $(modal)
      .find(".product__qty .down")
      .on("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        let currentVal = parseInt($(this).closest(".product__qty").find(".qty-input").val(), 10) || 1;
        if (currentVal > 1) {
          $(this)
            .closest(".product__qty")
            .find(".qty-input")
            .val(currentVal - 1)
            .prop("placeholder", currentVal - 1)
            .trigger("change");
        }
      });

    $(modal)
      .find(".modal-close")
      .on("click", function (e) {
        e.preventDefault();
        const bsModal = bootstrap.Modal.getInstance(modal[0]);
        if (bsModal) {
          bsModal.hide();
        }
      });

    $(modal).find('[data-bb-toggle="product-form"]').attr("data-update-url", "false");

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    $(modal).find(".productDetail__section--attributes").attr("data-no-url-update", "true");

    window.history.pushState = function () {
      const isQuickShop = $('.productDetail__section--attributes[data-no-url-update="true"]').length > 0;
      if (!isQuickShop) {
        return originalPushState.apply(window.history, arguments);
      }
    };

    window.history.replaceState = function () {
      const isQuickShop = $('.productDetail__section--attributes[data-no-url-update="true"]').length > 0;
      if (!isQuickShop) {
        return originalReplaceState.apply(window.history, arguments);
      }
    };

    // Restore original methods when modal is hidden
    $(modal).on("hidden.bs.modal", function () {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
      $(modal).find(".modal-body").html("");
      $(modal).find(".productDetail__section--attributes").removeAttr("data-no-url-update");
    });
  });

  const quickViewModal = $("#product-quickview");
  if (quickViewModal.length) {
    quickViewModal.on("hidden.bs.modal", function () {
      quickViewModal.find(".ps-product--quickview").html("");
    });
  }
});

$(document).on("click", ".bb-button-trigger-play-video", function (e) {
  const $button = $(e.currentTarget);
  const videoElement = document.getElementById($button.data("target"));

  videoElement.play();
  videoElement.controls = true;

  $button.closest(".bb-product-video").addClass("bb-product-video-playing");

  videoElement.addEventListener("ended", () => {
    $button.closest(".bb-product-video").removeClass("bb-product-video-playing");
    videoElement.controls = false;
    videoElement.currentTime = 0;
    videoElement.pause();
  });

  videoElement.addEventListener("pause", () => {
    if (videoElement.ended) return;
    $button.closest(".bb-product-video").removeClass("bb-product-video-playing");
    videoElement.controls = false;
  });
});
